import { ASSET_MANAGEMENT_TYPES } from "shared/types/asset";
import { CUSTOMER_SUPPORT_TYPES } from "shared/types/customersupport";
import { KO_DEVELOPMENT } from "shared/types/development";
import { BUDGET_CREATION_TYPES, FINANCIAL_OPERATIONS_TYPES, PROJECT_FINANCE_MANAGEMENT_TYPES } from "shared/types/finance";
import { HR_SERVICE_MANAGEMENT_TYPES, PERFORMANCE_REVIEW_TYPES, POLICY_MANAGEMENT_TYPES, RECRUITMENT_TYPES } from "shared/types/hr";
import { IT_SUPPORT } from "shared/types/itsupport";
import { CAMPAIGN_MANAGEMENT_TYPES, CONTENT_MANAGEMENT_TYPES, EMAIL_CAMPAIGN_TYPES, MARKETING_PROJECT_MANAGEMENT_TYPES } from "shared/types/marketing";
import { ORDER_MANAGEMENT_ISSUE_TYPES } from "shared/types/orders";
import { SALES_PIPELINE_TYPES, SALES_PROSPECTING_TYPES, SALES_SERVICE_TYPES } from "shared/types/sales";

const PROJECT_WORKFLOW = [
  {
    "workflowId": "",
    "name": "Backlog",
    "label": "Backlog",
    "value": 1,
    "background": "rgba(145, 158, 171, 0.16)",
    "color": "#637381",
    "nextStatuses": [
      { "label": "In Progress", "value": 2 },
      { "label": "Rejected", "value": 12 },
      { "label": "Duplicate", "value": 13 },
      { "label": "Deferred", "value": 14 },
      { "label": "Cancelled", "value": 15 }
    ]
  },
  {
    "workflowId": "",
    "name": "In Progress",
    "label": "In Progress",
    "value": 2,
    "background": "rgba(144, 202, 249, 0.16)",
    "color": "#1565c0",
    "nextStatuses": [
      { "label": "Code Review", "value": 3 },
      { "label": "Blocked", "value": 9 },
      { "label": "Backlog", "value": 1 }
    ]
  },
  {
    "workflowId": "",
    "name": "Code Review",
    "label": "Code Review",
    "value": 3,
    "background": "rgba(255, 204, 128, 0.16)",
    "color": "#ef6c00",
    "nextStatuses": [
      { "label": "QA Testing", "value": 4 },
      { "label": "In Progress", "value": 2 }
    ]
  },
  {
    "workflowId": "",
    "name": "QA Testing",
    "label": "QA Testing",
    "value": 4,
    "background": "rgba(165, 214, 167, 0.16)",
    "color": "#2e7d32",
    "nextStatuses": [
      { "label": "UAT Testing", "value": 5 },
      { "label": "In Progress", "value": 2 },
      { "label": "Retest", "value": 8 }
    ]
  },
  {
    "workflowId": "",
    "name": "UAT Testing",
    "label": "UAT Testing",
    "value": 5,
    "background": "rgba(255, 239, 179, 0.16)",
    "color": "#f9a825",
    "nextStatuses": [
      { "label": "Ready For Release", "value": 6 },
      { "label": "UAT Failed", "value": 10 }
    ]
  },
  {
    "workflowId": "",
    "name": "Ready For Release",
    "label": "Ready For Release",
    "value": 6,
    "background": "rgba(176, 190, 195, 0.16)",
    "color": "#455a64",
    "nextStatuses": [
      { "label": "Done", "value": 7 }
    ]
  },
  {
    "workflowId": "",
    "name": "Done",
    "label": "Done",
    "value": 7,
    "background": "rgba(200, 230, 201, 0.16)",
    "color": "#1b5e20",
    "nextStatuses": [
      { "label": "Reopened", "value": 11 }
    ]
  },
  {
    "workflowId": "",
    "name": "Retest",
    "label": "Retest",
    "value": 8,
    "background": "rgba(255, 241, 118, 0.16)",
    "color": "#fbc02d",
    "nextStatuses": [
      { "label": "QA Testing", "value": 4 },
      { "label": "Reopened", "value": 11 }
    ]
  },
  {
    "workflowId": "",
    "name": "Blocked",
    "label": "Blocked",
    "value": 9,
    "background": "rgba(255, 171, 145, 0.16)",
    "color": "#c62828",
    "nextStatuses": [
      { "label": "In Progress", "value": 2 }
    ]
  },
  {
    "workflowId": "",
    "name": "UAT Failed",
    "label": "UAT Failed",
    "value": 10,
    "background": "rgba(209, 164, 224, 0.16)",
    "color": "#6a1b9a",
    "nextStatuses": [
      { "label": "In Progress", "value": 2 }
    ]
  },
  {
    "workflowId": "",
    "name": "Reopened",
    "label": "Reopened",
    "value": 11,
    "background": "rgba(144, 202, 249, 0.16)",
    "color": "#0d47a1",
    "nextStatuses": [
      { "label": "In Progress", "value": 2 },
      { "label": "Retest", "value": 8 }
    ]
  },
  {
    "workflowId": "",
    "name": "Rejected",
    "label": "Rejected",
    "value": 12,
    "background": "rgba(239, 154, 154, 0.16)",
    "color": "#b71c1c",
    "nextStatuses": [ { "label": "Backlog", "value": 1 }]
  },
  {
    "workflowId": "",
    "name": "Duplicate",
    "label": "Duplicate",
    "value": 13,
    "background": "rgba(244, 143, 177, 0.16)",
    "color": "#ad1457",
    "nextStatuses": [ { "label": "Backlog", "value": 1 }]
  },
  {
    "workflowId": "",
    "name": "Deferred",
    "label": "Deferred",
    "value": 14,
    "background": "rgba(189, 189, 189, 0.16)",
    "color": "#616161",
    "nextStatuses": [ { "label": "Backlog", "value": 1 }]
  },
  {
    "workflowId": "",
    "name": "Cancelled",
    "label": "Cancelled",
    "value": 15,
    "background": "rgba(158, 158, 158, 0.16)",
    "color": "#424242",
    "nextStatuses": [ { "label": "Backlog", "value": 1 }]
  }
];
const ORDER_WORKFLOW = [
  {
    label: 'New Order',
    value: 1,
    name: 'New Order',
    background: 'rgba(145, 158, 171, 0.16)',
    color: '#637381',
    nextStatuses: [
      { label: 'Processing', value: 2, name: 'Processing', background: 'rgba(255, 239, 179, 0.16)', color: '#f57f17' },
      { label: 'On Hold', value: 6, name: 'On Hold', background: 'rgba(255, 204, 128, 0.16)', color: '#ff8f00' },
      { label: 'Cancelled', value: 8, name: 'Cancelled', background: 'rgba(244, 143, 177, 0.16)', color: '#d81b60' }
    ]
  },
  {
    label: 'Processing',
    value: 2,
    name: 'Processing',
    background: 'rgba(255, 239, 179, 0.16)',
    color: '#f57f17',
    nextStatuses: [
      { label: 'Shipped', value: 3, name: 'Shipped', background: 'rgba(144, 202, 249, 0.16)', color: '#0d47a1' },
      { label: 'On Hold', value: 6, name: 'On Hold', background: 'rgba(255, 204, 128, 0.16)', color: '#ff8f00' },
      { label: 'Cancelled', value: 8, name: 'Cancelled', background: 'rgba(244, 143, 177, 0.16)', color: '#d81b60' }
    ]
  },
  {
    label: 'Shipped',
    value: 3,
    name: 'Shipped',
    background: 'rgba(144, 202, 249, 0.16)',
    color: '#0d47a1',
    nextStatuses: [
      { label: 'Delivered', value: 4, name: 'Delivered', background: 'rgba(165, 214, 167, 0.16)', color: '#388e3c' },
      { label: 'Returned', value: 5, name: 'Returned', background: 'rgba(255, 171, 145, 0.16)', color: '#c62828' }
    ]
  },
  {
    label: 'Delivered',
    value: 4,
    name: 'Delivered',
    background: 'rgba(165, 214, 167, 0.16)',
    color: '#388e3c',
    nextStatuses: [
      { label: 'Completed', value: 7, name: 'Completed', background: 'rgba(200, 230, 201, 0.16)', color: '#4caf50' },
      { label: 'Returned', value: 5, name: 'Returned', background: 'rgba(255, 171, 145, 0.16)', color: '#c62828' }
    ]
  },
  {
    label: 'Returned',
    value: 5,
    name: 'Returned',
    background: 'rgba(255, 171, 145, 0.16)',
    color: '#c62828',
    nextStatuses: [
      { label: 'Refunded', value: 9, name: 'Refunded', background: 'rgba(176, 190, 195, 0.16)', color: '#37474f' },
      { label: 'Replaced', value: 10, name: 'Replaced', background: 'rgba(209, 164, 224, 0.16)', color: '#6a1b9a' }
    ]
  },
  {
    label: 'On Hold',
    value: 6,
    name: 'On Hold',
    background: 'rgba(255, 204, 128, 0.16)',
    color: '#ff8f00',
    nextStatuses: [
      { label: 'Processing', value: 2, name: 'Processing', background: 'rgba(255, 239, 179, 0.16)', color: '#f57f17' },
      { label: 'Cancelled', value: 8, name: 'Cancelled', background: 'rgba(244, 143, 177, 0.16)', color: '#d81b60' }
    ]
  },
  {
    label: 'Completed',
    value: 7,
    name: 'Completed',
    background: 'rgba(200, 230, 201, 0.16)',
    color: '#4caf50',
    nextStatuses: []
  },
  {
    label: 'Cancelled',
    value: 8,
    name: 'Cancelled',
    background: 'rgba(244, 143, 177, 0.16)',
    color: '#d81b60',
    nextStatuses: []
  },
  {
    label: 'Refunded',
    value: 9,
    name: 'Refunded',
    background: 'rgba(176, 190, 195, 0.16)',
    color: '#37474f',
    nextStatuses: []
  },
  {
    label: 'Replaced',
    value: 10,
    name: 'Replaced',
    background: 'rgba(209, 164, 224, 0.16)',
    color: '#6a1b9a',
    nextStatuses: [
      { label: 'Shipped', value: 3, name: 'Shipped', background: 'rgba(144, 202, 249, 0.16)', color: '#0d47a1' }
    ]
  }
];

const SALES_LEAD_WORKFLOW = [
  {
    label: 'Lead',
    value: 1,
    name: 'Lead',
    background: 'rgba(145, 158, 171, 0.16)',
    color: '#637381',
    nextStatuses: [
      { label: 'Contacted', value: 2, name: 'Contacted', background: 'rgba(187, 222, 251, 0.16)', color: '#0277bd' },
      { label: 'Disqualified', value: 7, name: 'Disqualified', background: 'rgba(244, 143, 177, 0.16)', color: '#d81b60' }
    ]
  },
  {
    label: 'Contacted',
    value: 2,
    name: 'Contacted',
    background: 'rgba(187, 222, 251, 0.16)',
    color: '#0277bd',
    nextStatuses: [
      { label: 'Qualified', value: 3, name: 'Qualified', background: 'rgba(255, 241, 118, 0.16)', color: '#f9a825' },
      { label: 'Disqualified', value: 7, name: 'Disqualified', background: 'rgba(244, 143, 177, 0.16)', color: '#d81b60' }
    ]
  },
  {
    label: 'Qualified',
    value: 3,
    name: 'Qualified',
    background: 'rgba(255, 241, 118, 0.16)',
    color: '#f9a825',
    nextStatuses: [
      { label: 'Proposal Sent', value: 4, name: 'Proposal Sent', background: 'rgba(129, 212, 250, 0.16)', color: '#0288d1' },
      { label: 'Disqualified', value: 7, name: 'Disqualified', background: 'rgba(244, 143, 177, 0.16)', color: '#d81b60' }
    ]
  },
  {
    label: 'Proposal Sent',
    value: 4,
    name: 'Proposal Sent',
    background: 'rgba(129, 212, 250, 0.16)',
    color: '#0288d1',
    nextStatuses: [
      { label: 'Negotiation', value: 5, name: 'Negotiation', background: 'rgba(255, 183, 77, 0.16)', color: '#ef6c00' },
      { label: 'Lost', value: 8, name: 'Lost', background: 'rgba(239, 154, 154, 0.16)', color: '#e53935' }
    ]
  },
  {
    label: 'Negotiation',
    value: 5,
    name: 'Negotiation',
    background: 'rgba(255, 183, 77, 0.16)',
    color: '#ef6c00',
    nextStatuses: [
      { label: 'Won', value: 6, name: 'Won', background: 'rgba(165, 214, 167, 0.16)', color: '#388e3c' },
      { label: 'Lost', value: 8, name: 'Lost', background: 'rgba(239, 154, 154, 0.16)', color: '#e53935' }
    ]
  },
  {
    label: 'Won',
    value: 6,
    name: 'Won',
    background: 'rgba(165, 214, 167, 0.16)',
    color: '#388e3c',
    nextStatuses: []
  },
  {
    label: 'Disqualified',
    value: 7,
    name: 'Disqualified',
    background: 'rgba(244, 143, 177, 0.16)',
    color: '#d81b60',
    nextStatuses: []
  },
  {
    label: 'Lost',
    value: 8,
    name: 'Lost',
    background: 'rgba(239, 154, 154, 0.16)',
    color: '#e53935',
    nextStatuses: []
  }
];

const SALES_SERVICE_WORKFLOW = [
  {
    label: "Lead",
    value: 1,
    name: "Lead",
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fdd835",
    nextStatuses: [
      { label: "Qualified", value: 2, name: "Qualified", background: "rgba(129, 212, 250, 0.16)", color: "#0288d1" },
      { label: "Unqualified", value: 3, name: "Unqualified", background: "rgba(239, 83, 80, 0.16)", color: "#e53935" }
    ]
  },
  {
    label: "Qualified",
    value: 2,
    name: "Qualified",
    background: "rgba(129, 212, 250, 0.16)",
    color: "#0288d1",
    nextStatuses: [
      { label: "Proposal Sent", value: 4, name: "Proposal Sent", background: "rgba(206, 147, 216, 0.16)", color: "#7b1fa2" }
    ]
  },
  {
    label: "Unqualified",
    value: 3,
    name: "Unqualified",
    background: "rgba(239, 83, 80, 0.16)",
    color: "#e53935",
    nextStatuses: []
  },
  {
    label: "Proposal Sent",
    value: 4,
    name: "Proposal Sent",
    background: "rgba(206, 147, 216, 0.16)",
    color: "#7b1fa2",
    nextStatuses: [
      { label: "Negotiation", value: 5, name: "Negotiation", background: "rgba(255, 204, 128, 0.16)", color: "#ff8f00" },
      { label: "Rejected", value: 6, name: "Rejected", background: "rgba(239, 83, 80, 0.16)", color: "#e53935" }
    ]
  },
  {
    label: "Negotiation",
    value: 5,
    name: "Negotiation",
    background: "rgba(255, 204, 128, 0.16)",
    color: "#ff8f00",
    nextStatuses: [
      { label: "Closed Won", value: 7, name: "Closed Won", background: "rgba(165, 214, 167, 0.16)", color: "#388e3c" },
      { label: "Closed Lost", value: 8, name: "Closed Lost", background: "rgba(239, 83, 80, 0.16)", color: "#e53935" }
    ]
  },
  {
    label: "Closed Won",
    value: 7,
    name: "Closed Won",
    background: "rgba(165, 214, 167, 0.16)",
    color: "#388e3c",
    nextStatuses: [
      { label: "Service Initiated", value: 9, name: "Service Initiated", background: "rgba(144, 202, 249, 0.16)", color: "#1976d2" }
    ]
  },
  {
    label: "Closed Lost",
    value: 8,
    name: "Closed Lost",
    background: "rgba(239, 83, 80, 0.16)",
    color: "#e53935",
    nextStatuses: []
  },
  {
    label: "Service Initiated",
    value: 9,
    name: "Service Initiated",
    background: "rgba(144, 202, 249, 0.16)",
    color: "#1976d2",
    nextStatuses: [
      { label: "In Service", value: 10, name: "In Service", background: "rgba(255, 241, 118, 0.16)", color: "#fdd835" }
    ]
  },
  {
    label: "In Service",
    value: 10,
    name: "In Service",
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fdd835",
    nextStatuses: [
      { label: "Completed", value: 11, name: "Completed", background: "rgba(129, 199, 132, 0.16)", color: "#43a047" },
      { label: "Escalated", value: 12, name: "Escalated", background: "rgba(255, 138, 128, 0.16)", color: "#d32f2f" }
    ]
  },
  {
    label: "Completed",
    value: 11,
    name: "Completed",
    background: "rgba(129, 199, 132, 0.16)",
    color: "#43a047",
    nextStatuses: []
  },
  {
    label: "Escalated",
    value: 12,
    name: "Escalated",
    background: "rgba(255, 138, 128, 0.16)",
    color: "#d32f2f",
    nextStatuses: [
      { label: "Resolved", value: 13, name: "Resolved", background: "rgba(174, 213, 129, 0.16)", color: "#689f38" }
    ]
  },
  {
    label: "Resolved",
    value: 13,
    name: "Resolved",
    background: "rgba(174, 213, 129, 0.16)",
    color: "#689f38",
    nextStatuses: []
  }
];

const PROJECT_MARKETING_MANAGEMENT_WORKFLOW = [
  {
    label: "Initiation",
    value: 1,
    name: "Initiation",
    nextStatuses: [
      { label: "Planning", value: 2, name: "Planning" }
    ],
    background: "rgba(144, 202, 249, 0.16)",
    color: "#1976d2"
  },
  {
    label: "Planning",
    value: 2,
    name: "Planning",
    nextStatuses: [
      { label: "Execution", value: 3, name: "Execution" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Execution",
    value: 3,
    name: "Execution",
    nextStatuses: [
      { label: "Monitoring & Controlling", value: 4, name: "Monitoring & Controlling" },
      { label: "On Hold", value: 6, name: "On Hold" }
    ],
    background: "rgba(129, 199, 132, 0.16)",
    color: "#43a047"
  },
  {
    label: "Monitoring & Controlling",
    value: 4,
    name: "Monitoring & Controlling",
    nextStatuses: [
      { label: "Closure", value: 5, name: "Closure" },
      { label: "On Hold", value: 6, name: "On Hold" }
    ],
    background: "rgba(100, 181, 246, 0.16)",
    color: "#1e88e5"
  },
  {
    label: "Closure",
    value: 5,
    name: "Closure",
    nextStatuses: [],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#388e3c"
  },
  {
    label: "On Hold",
    value: 6,
    name: "On Hold",
    nextStatuses: [
      { label: "Execution", value: 3, name: "Execution" },
      { label: "Monitoring & Controlling", value: 4, name: "Monitoring & Controlling" },
      { label: "Cancelled", value: 7, name: "Cancelled" }
    ],
    background: "rgba(255, 213, 79, 0.16)",
    color: "#ffa000"
  },
  {
    label: "Cancelled",
    value: 7,
    name: "Cancelled",
    nextStatuses: [],
    background: "rgba(244, 67, 54, 0.16)",
    color: "#d32f2f"
  }
];

const CAMPAIGN_MANAGEMENT_WORKFLOW = [
  {
    label: "Ideation",
    value: 1,
    name: "Ideation",
    nextStatuses: [
      { label: "Planning", value: 2, name: "Planning" }
    ],
    background: "rgba(179, 229, 252, 0.16)",
    color: "#0288d1"
  },
  {
    label: "Planning",
    value: 2,
    name: "Planning",
    nextStatuses: [
      { label: "Production", value: 3, name: "Production" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Production",
    value: 3,
    name: "Production",
    nextStatuses: [
      { label: "Launch", value: 4, name: "Launch" },
      { label: "On Hold", value: 6, name: "On Hold" }
    ],
    background: "rgba(255, 224, 178, 0.16)",
    color: "#fb8c00"
  },
  {
    label: "Launch",
    value: 4,
    name: "Launch",
    nextStatuses: [
      { label: "Monitoring", value: 5, name: "Monitoring" }
    ],
    background: "rgba(129, 199, 132, 0.16)",
    color: "#43a047"
  },
  {
    label: "Monitoring",
    value: 5,
    name: "Monitoring",
    nextStatuses: [
      { label: "Completed", value: 7, name: "Completed" },
      { label: "On Hold", value: 6, name: "On Hold" }
    ],
    background: "rgba(100, 181, 246, 0.16)",
    color: "#1e88e5"
  },
  {
    label: "On Hold",
    value: 6,
    name: "On Hold",
    nextStatuses: [
      { label: "Production", value: 3, name: "Production" },
      { label: "Monitoring", value: 5, name: "Monitoring" },
      { label: "Cancelled", value: 8, name: "Cancelled" }
    ],
    background: "rgba(255, 213, 79, 0.16)",
    color: "#ffa000"
  },
  {
    label: "Completed",
    value: 7,
    name: "Completed",
    nextStatuses: [],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#388e3c"
  },
  {
    label: "Cancelled",
    value: 8,
    name: "Cancelled",
    nextStatuses: [],
    background: "rgba(244, 67, 54, 0.16)",
    color: "#d32f2f"
  }
];

const CONTENT_MANAGEMENT_WORKFLOW = [
  {
    label: "Draft",
    value: 1,
    name: "Draft",
    nextStatuses: [
      { label: "Review", value: 2, name: "Review" }
    ],
    background: "rgba(206, 147, 216, 0.16)",
    color: "#8e24aa"
  },
  {
    label: "Review",
    value: 2,
    name: "Review",
    nextStatuses: [
      { label: "Approved", value: 3, name: "Approved" },
      { label: "Needs Revisions", value: 4, name: "Needs Revisions" }
    ],
    background: "rgba(179, 229, 252, 0.16)",
    color: "#0288d1"
  },
  {
    label: "Needs Revisions",
    value: 4,
    name: "Needs Revisions",
    nextStatuses: [
      { label: "Draft", value: 1, name: "Draft" }
    ],
    background: "rgba(255, 204, 128, 0.16)",
    color: "#fb8c00"
  },
  {
    label: "Approved",
    value: 3,
    name: "Approved",
    nextStatuses: [
      { label: "Scheduled", value: 5, name: "Scheduled" }
    ],
    background: "rgba(165, 214, 167, 0.16)",
    color: "#388e3c"
  },
  {
    label: "Scheduled",
    value: 5,
    name: "Scheduled",
    nextStatuses: [
      { label: "Published", value: 6, name: "Published" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Published",
    value: 6,
    name: "Published",
    nextStatuses: [],
    background: "rgba(129, 199, 132, 0.16)",
    color: "#43a047"
  }
];

// const EVENT_WORKFLOW = [
//   {
//     label: "Planning",
//     name: "Planning",
//     value: 1,
//     color: "#65789B",
//     background: "rgba(101, 120, 155, 0.1)",
//     nextStatuses: [
//       { label: "Approval", name: "Approval", value: 2 }
//     ]
//   },
//   {
//     label: "Approval",
//     name: "Approval",
//     value: 2,
//     color: "#61DDAA",
//     background: "rgba(97, 221, 170, 0.1)",
//     nextStatuses: [
//       { label: "Approved", name: "Approved", value: 3 },
//       { label: "Rejected", name: "Rejected", value: 4 }
//     ]
//   },
//   {
//     label: "Approved",
//     name: "Approved",
//     value: 3,
//     color: "#00B8D9",
//     background: "rgba(0, 184, 217, 0.1)",
//     nextStatuses: [
//       { label: "Ongoing", name: "Ongoing", value: 5 }
//     ]
//   },
//   {
//     label: "Rejected",
//     name: "Rejected",
//     value: 4,
//     color: "#F5222D",
//     background: "rgba(245, 34, 45, 0.1)",
//     nextStatuses: [
//       { label: "Planning", name: "Planning", value: 1 }
//     ]
//   },
//   {
//     label: "Ongoing",
//     name: "Ongoing",
//     value: 5,
//     color: "#6DC8EC",
//     background: "rgba(109, 200, 236, 0.1)",
//     nextStatuses: [
//       { label: "Feedback", name: "Feedback", value: 6 },
//       { label: "Cancelled", name: "Cancelled", value: 7 }
//     ]
//   },
//   {
//     label: "Feedback",
//     name: "Feedback",
//     value: 6,
//     color: "#B37FEB",
//     background: "rgba(179, 127, 235, 0.1)",
//     nextStatuses: [
//       { label: "Closed", name: "Closed", value: 8 }
//     ]
//   },
//   {
//     label: "Cancelled",
//     name: "Cancelled",
//     value: 7,
//     color: "#FAAD14",
//     background: "rgba(250, 173, 20, 0.1)",
//     nextStatuses: [
//       { label: "Planning", name: "Planning", value: 1 }
//     ]
//   },
//   {
//     label: "Closed",
//     name: "Closed",
//     value: 8,
//     color: "#C2C8D5",
//     background: "rgba(194, 200, 213, 0.1)",
//     nextStatuses: [{ label: "Planning", name: "Planning", value: 1 }]
//   }
// ];





const EMAIL_CAMPAIGN_WORKFLOW = [
  {
    label: "Idea",
    value: 1,
    name: "Idea",
    nextStatuses: [
      { label: "Content Creation", value: 2, name: "Content Creation" }
    ],
    background: "rgba(179, 229, 252, 0.16)",
    color: "#0288d1"
  },
  {
    label: "Content Creation",
    value: 2,
    name: "Content Creation",
    nextStatuses: [
      { label: "Design", value: 3, name: "Design" }
    ],
    background: "rgba(206, 147, 216, 0.16)",
    color: "#8e24aa"
  },
  {
    label: "Design",
    value: 3,
    name: "Design",
    nextStatuses: [
      { label: "Approval", value: 4, name: "Approval" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Approval",
    value: 4,
    name: "Approval",
    nextStatuses: [
      { label: "Scheduled", value: 5, name: "Scheduled" }
    ],
    background: "rgba(129, 199, 132, 0.16)",
    color: "#43a047"
  },
  {
    label: "Scheduled",
    value: 5,
    name: "Scheduled",
    nextStatuses: [
      { label: "Sent", value: 6, name: "Sent" }
    ],
    background: "rgba(144, 202, 249, 0.16)",
    color: "#1976d2"
  },
  {
    label: "Sent",
    value: 6,
    name: "Sent",
    nextStatuses: [
      { label: "Analysis", value: 7, name: "Analysis" }
    ],
    background: "rgba(165, 214, 167, 0.16)",
    color: "#388e3c"
  },
  {
    label: "Analysis",
    value: 7,
    name: "Analysis",
    nextStatuses: [],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#2e7d32"
  }
];

const PROJECT_SALES_MANAGEMENT_WORKFLOW = [
  {
    label: "Initiation",
    value: 1,
    name: "Initiation",
    nextStatuses: [
      { label: "Planning", value: 2, name: "Planning" }
    ],
    background: "rgba(144, 202, 249, 0.16)",
    color: "#1976d2"
  },
  {
    label: "Planning",
    value: 2,
    name: "Planning",
    nextStatuses: [
      { label: "Execution", value: 3, name: "Execution" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Execution",
    value: 3,
    name: "Execution",
    nextStatuses: [
      { label: "Monitoring", value: 4, name: "Monitoring" },
      { label: "On Hold", value: 6, name: "On Hold" }
    ],
    background: "rgba(129, 199, 132, 0.16)",
    color: "#43a047"
  },
  {
    label: "Monitoring",
    value: 4,
    name: "Monitoring",
    nextStatuses: [
      { label: "Closing", value: 5, name: "Closing" }
    ],
    background: "rgba(206, 147, 216, 0.16)",
    color: "#8e24aa"
  },
  {
    label: "Closing",
    value: 5,
    name: "Closing",
    nextStatuses: [],
    background: "rgba(165, 214, 167, 0.16)",
    color: "#388e3c"
  },
  {
    label: "On Hold",
    value: 6,
    name: "On Hold",
    nextStatuses: [
      { label: "Execution", value: 3, name: "Execution" },
      { label: "Planning", value: 2, name: "Planning" }
    ],
    background: "rgba(255, 224, 178, 0.16)",
    color: "#fb8c00"
  }
];

const FINANCE_SERVICE_WORKFLOW = [
  {
    label: "Request Initiated",
    value: 1,
    name: "Request Initiated",
    nextStatuses: [
      { label: "Under Review", value: 2, name: "Under Review" }
    ],
    background: "rgba(187, 222, 251, 0.16)",
    color: "#2196f3"
  },
  {
    label: "Under Review",
    value: 2,
    name: "Under Review",
    nextStatuses: [
      { label: "Approved", value: 3, name: "Approved" },
      { label: "Rejected", value: 4, name: "Rejected" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Approved",
    value: 3,
    name: "Approved",
    nextStatuses: [
      { label: "Disbursed", value: 5, name: "Disbursed" }
    ],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#4caf50"
  },
  {
    label: "Rejected",
    value: 4,
    name: "Rejected",
    nextStatuses: [],
    background: "rgba(255, 205, 210, 0.16)",
    color: "#e53935"
  },
  {
    label: "Disbursed",
    value: 5,
    name: "Disbursed",
    nextStatuses: [
      { label: "Closed", value: 6, name: "Closed" }
    ],
    background: "rgba(178, 223, 219, 0.16)",
    color: "#00796b"
  },
  {
    label: "Closed",
    value: 6,
    name: "Closed",
    nextStatuses: [],
    background: "rgba(224, 224, 224, 0.16)",
    color: "#757575"
  }
];

const BUDGET_CREATION_WORKFLOW = [
  {
    label: "Draft",
    value: 1,
    name: "Draft",
    nextStatuses: [
      { label: "Under Review", value: 2, name: "Under Review" }
    ],
    background: "rgba(144, 202, 249, 0.16)",
    color: "#1976d2"
  },
  {
    label: "Under Review",
    value: 2,
    name: "Under Review",
    nextStatuses: [
      { label: "Approved", value: 3, name: "Approved" },
      { label: "Rejected", value: 4, name: "Rejected" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Approved",
    value: 3,
    name: "Approved",
    nextStatuses: [
      { label: "Published", value: 5, name: "Published" }
    ],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#43a047"
  },
  {
    label: "Rejected",
    value: 4,
    name: "Rejected",
    nextStatuses: [
      { label: "Draft", value: 1, name: "Draft" }
    ],
    background: "rgba(255, 205, 210, 0.16)",
    color: "#e53935"
  },
  {
    label: "Published",
    value: 5,
    name: "Published",
    nextStatuses: [],
    background: "rgba(178, 223, 219, 0.16)",
    color: "#00796b"
  }
];

const PROJECT_FINANCE_MANAGEMENT_WORKFLOW = [
  {
    label: "Budget Allocation",
    value: 1,
    name: "Budget Allocation",
    nextStatuses: [
      { label: "Expense Tracking", value: 2, name: "Expense Tracking" }
    ],
    background: "rgba(255, 213, 79, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Expense Tracking",
    value: 2,
    name: "Expense Tracking",
    nextStatuses: [
      { label: "Variance Analysis", value: 3, name: "Variance Analysis" }
    ],
    background: "rgba(179, 229, 252, 0.16)",
    color: "#0288d1"
  },
  {
    label: "Variance Analysis",
    value: 3,
    name: "Variance Analysis",
    nextStatuses: [
      { label: "Financial Reporting", value: 4, name: "Financial Reporting" }
    ],
    background: "rgba(206, 147, 216, 0.16)",
    color: "#8e24aa"
  },
  {
    label: "Financial Reporting",
    value: 4,
    name: "Financial Reporting",
    nextStatuses: [
      { label: "Audit", value: 5, name: "Audit" }
    ],
    background: "rgba(165, 214, 167, 0.16)",
    color: "#388e3c"
  },
  {
    label: "Audit",
    value: 5,
    name: "Audit",
    nextStatuses: [
      { label: "Closed", value: 6, name: "Closed" }
    ],
    background: "rgba(244, 143, 177, 0.16)",
    color: "#d81b60"
  },
  {
    label: "Closed",
    value: 6,
    name: "Closed",
    nextStatuses: [],
    background: "rgba(224, 224, 224, 0.16)",
    color: "#616161"
  }
];

const HR_SERVICE_MANAGEMENT_WORKFLOW = [
  {
    label: "Request Submitted",
    value: 1,
    name: "Request Submitted",
    nextStatuses: [
      { label: "Assigned", value: 2, name: "Assigned" }
    ],
    background: "rgba(187, 222, 251, 0.16)",
    color: "#2196f3"
  },
  {
    label: "Assigned",
    value: 2,
    name: "Assigned",
    nextStatuses: [
      { label: "In Progress", value: 3, name: "In Progress" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "In Progress",
    value: 3,
    name: "In Progress",
    nextStatuses: [
      { label: "Resolved", value: 4, name: "Resolved" },
      { label: "Escalated", value: 5, name: "Escalated" }
    ],
    background: "rgba(255, 224, 178, 0.16)",
    color: "#fb8c00"
  },
  {
    label: "Resolved",
    value: 4,
    name: "Resolved",
    nextStatuses: [
      { label: "Closed", value: 6, name: "Closed" }
    ],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#4caf50"
  },
  {
    label: "Escalated",
    value: 5,
    name: "Escalated",
    nextStatuses: [
      { label: "Resolved", value: 4, name: "Resolved" }
    ],
    background: "rgba(255, 205, 210, 0.16)",
    color: "#e53935"
  },
  {
    label: "Closed",
    value: 6,
    name: "Closed",
    nextStatuses: [],
    background: "rgba(224, 224, 224, 0.16)",
    color: "#757575"
  }
];

const RECRUITMENT_WORKFLOW = [
  {
    label: "Job Opening Created",
    value: 1,
    name: "Job Opening Created",
    nextStatuses: [
      { label: "Applications Received", value: 2, name: "Applications Received" }
    ],
    background: "rgba(179, 229, 252, 0.16)",
    color: "#0288d1"
  },
  {
    label: "Applications Received",
    value: 2,
    name: "Applications Received",
    nextStatuses: [
      { label: "Shortlisted", value: 3, name: "Shortlisted" }
    ],
    background: "rgba(144, 202, 249, 0.16)",
    color: "#1976d2"
  },
  {
    label: "Shortlisted",
    value: 3,
    name: "Shortlisted",
    nextStatuses: [
      { label: "Interviewing", value: 4, name: "Interviewing" }
    ],
    background: "rgba(255, 213, 79, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Interviewing",
    value: 4,
    name: "Interviewing",
    nextStatuses: [
      { label: "Selected", value: 5, name: "Selected" },
      { label: "Rejected", value: 6, name: "Rejected" }
    ],
    background: "rgba(255, 224, 178, 0.16)",
    color: "#fb8c00"
  },
  {
    label: "Selected",
    value: 5,
    name: "Selected",
    nextStatuses: [
      { label: "Offer Extended", value: 7, name: "Offer Extended" }
    ],
    background: "rgba(165, 214, 167, 0.16)",
    color: "#388e3c"
  },
  {
    label: "Offer Extended",
    value: 7,
    name: "Offer Extended",
    nextStatuses: [
      { label: "Hired", value: 8, name: "Hired" },
      { label: "Offer Declined", value: 9, name: "Offer Declined" }
    ],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#4caf50"
  },
  {
    label: "Hired",
    value: 8,
    name: "Hired",
    nextStatuses: [],
    background: "rgba(178, 223, 219, 0.16)",
    color: "#00796b"
  },
  {
    label: "Offer Declined",
    value: 9,
    name: "Offer Declined",
    nextStatuses: [],
    background: "rgba(255, 205, 210, 0.16)",
    color: "#e53935"
  },
  {
    label: "Rejected",
    value: 6,
    name: "Rejected",
    nextStatuses: [],
    background: "rgba(244, 143, 177, 0.16)",
    color: "#d81b60"
  }
];


const POLICY_MANAGEMENT_WORKFLOW = [
  {
    label: "Draft",
    value: 1,
    name: "Draft",
    nextStatuses: [
      { label: "Under Review", value: 2, name: "Under Review" }
    ],
    background: "rgba(187, 222, 251, 0.16)",
    color: "#2196f3"
  },
  {
    label: "Under Review",
    value: 2,
    name: "Under Review",
    nextStatuses: [
      { label: "Approved", value: 3, name: "Approved" },
      { label: "Rejected", value: 4, name: "Rejected" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Approved",
    value: 3,
    name: "Approved",
    nextStatuses: [
      { label: "Published", value: 5, name: "Published" }
    ],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#4caf50"
  },
  {
    label: "Rejected",
    value: 4,
    name: "Rejected",
    nextStatuses: [
      { label: "Draft", value: 1, name: "Draft" }
    ],
    background: "rgba(255, 205, 210, 0.16)",
    color: "#e53935"
  },
  {
    label: "Published",
    value: 5,
    name: "Published",
    nextStatuses: [],
    background: "rgba(178, 223, 219, 0.16)",
    color: "#00796b"
  }
];


const PERFORMANCE_REVIEW_WORKFLOW = [
  {
    label: "Review Started",
    value: 1,
    name: "Review Started",
    nextStatuses: [
      { label: "Self Assessment", value: 2, name: "Self Assessment" }
    ],
    background: "rgba(179, 229, 252, 0.16)",
    color: "#0288d1"
  },
  {
    label: "Self Assessment",
    value: 2,
    name: "Self Assessment",
    nextStatuses: [
      { label: "Manager Review", value: 3, name: "Manager Review" }
    ],
    background: "rgba(144, 202, 249, 0.16)",
    color: "#1976d2"
  },
  {
    label: "Manager Review",
    value: 3,
    name: "Manager Review",
    nextStatuses: [
      { label: "Final Review", value: 4, name: "Final Review" }
    ],
    background: "rgba(206, 147, 216, 0.16)",
    color: "#8e24aa"
  },
  {
    label: "Final Review",
    value: 4,
    name: "Final Review",
    nextStatuses: [
      { label: "Completed", value: 5, name: "Completed" }
    ],
    background: "rgba(165, 214, 167, 0.16)",
    color: "#388e3c"
  },
  {
    label: "Completed",
    value: 5,
    name: "Completed",
    nextStatuses: [],
    background: "rgba(224, 224, 224, 0.16)",
    color: "#757575"
  }
];

const IT_SERVICE_MANAGEMENT_WORKFLOW = [
  {
    label: "Ticket Created",
    value: 1,
    name: "Ticket Created",
    nextStatuses: [
      { label: "Categorized", value: 2, name: "Categorized" }
    ],
    background: "rgba(187, 222, 251, 0.16)",
    color: "#2196f3"
  },
  {
    label: "Categorized",
    value: 2,
    name: "Categorized",
    nextStatuses: [
      { label: "Assigned", value: 3, name: "Assigned" }
    ],
    background: "rgba(255, 241, 118, 0.16)",
    color: "#fbc02d"
  },
  {
    label: "Assigned",
    value: 3,
    name: "Assigned",
    nextStatuses: [
      { label: "In Progress", value: 4, name: "In Progress" }
    ],
    background: "rgba(255, 224, 178, 0.16)",
    color: "#fb8c00"
  },
  {
    label: "In Progress",
    value: 4,
    name: "In Progress",
    nextStatuses: [
      { label: "Resolved", value: 5, name: "Resolved" },
      { label: "Pending Info", value: 6, name: "Pending Info" }
    ],
    background: "rgba(129, 212, 250, 0.16)",
    color: "#03a9f4"
  },
  {
    label: "Pending Info",
    value: 6,
    name: "Pending Info",
    nextStatuses: [
      { label: "In Progress", value: 4, name: "In Progress" }
    ],
    background: "rgba(255, 213, 79, 0.16)",
    color: "#ffa000"
  },
  {
    label: "Resolved",
    value: 5,
    name: "Resolved",
    nextStatuses: [
      { label: "Closed", value: 7, name: "Closed" }
    ],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#4caf50"
  },
  {
    label: "Closed",
    value: 7,
    name: "Closed",
    nextStatuses: [],
    background: "rgba(224, 224, 224, 0.16)",
    color: "#757575"
  }
];

const CUSTOMER_SUPPORT_WORKFLOW = [
  {
    label: "New Request",
    value: 1,
    name: "New Request",
    nextStatuses: [
      { label: "Assigned", value: 2, name: "Assigned" }
    ],
    background: "rgba(187, 222, 251, 0.16)",
    color: "#2196f3"
  },
  {
    label: "Assigned",
    value: 2,
    name: "Assigned",
    nextStatuses: [
      { label: "In Progress", value: 3, name: "In Progress" },
      { label: "Awaiting Customer Response", value: 4, name: "Awaiting Customer Response" }
    ],
    background: "rgba(255, 236, 179, 0.16)",
    color: "#f9a825"
  },
  {
    label: "In Progress",
    value: 3,
    name: "In Progress",
    nextStatuses: [
      { label: "Resolved", value: 5, name: "Resolved" },
      { label: "Escalated", value: 6, name: "Escalated" }
    ],
    background: "rgba(129, 212, 250, 0.16)",
    color: "#03a9f4"
  },
  {
    label: "Awaiting Customer Response",
    value: 4,
    name: "Awaiting Customer Response",
    nextStatuses: [
      { label: "In Progress", value: 3, name: "In Progress" },
      { label: "Resolved", value: 5, name: "Resolved" }
    ],
    background: "rgba(255, 213, 79, 0.16)",
    color: "#ffa000"
  },
  {
    label: "Resolved",
    value: 5,
    name: "Resolved",
    nextStatuses: [
      { label: "Closed", value: 7, name: "Closed" }
    ],
    background: "rgba(200, 230, 201, 0.16)",
    color: "#4caf50"
  },
  {
    label: "Escalated",
    value: 6,
    name: "Escalated",
    nextStatuses: [
      { label: "In Progress", value: 3, name: "In Progress" },
      { label: "Resolved", value: 5, name: "Resolved" }
    ],
    background: "rgba(255, 138, 128, 0.16)",
    color: "#e53935"
  },
  {
    label: "Closed",
    value: 7,
    name: "Closed",
    nextStatuses: [],
    background: "rgba(224, 224, 224, 0.16)",
    color: "#757575"
  }
];

const ASSET_MANAGEMENT_WORKFLOW = [
  {
    label: "Draft",
    name: "Draft",
    value: 1,
    background: "rgba(145,158,171,0.16)",
    color: "#637381",
    nextStatuses: [
      {
        label: "Submitted",
        name: "Submitted",
        value: 2,
        background: "rgba(144,202,249,0.16)",
        color: "#0288d1"
      }
    ]
  },
  {
    label: "Submitted",
    name: "Submitted",
    value: 2,
    background: "rgba(144,202,249,0.16)",
    color: "#0288d1",
    nextStatuses: [
      {
        label: "Approved",
        name: "Approved",
        value: 3,
        background: "rgba(165,214,167,0.16)",
        color: "#388e3c"
      },
      {
        label: "Rejected",
        name: "Rejected",
        value: 4,
        background: "rgba(255,171,145,0.16)",
        color: "#d32f2f"
      }
    ]
  },
  {
    label: "Approved",
    name: "Approved",
    value: 3,
    background: "rgba(165,214,167,0.16)",
    color: "#388e3c",
    nextStatuses: [
      {
        label: "Assigned",
        name: "Assigned",
        value: 5,
        background: "rgba(255,249,196,0.16)",
        color: "#fbc02d"
      }
    ]
  },
  {
    label: "Rejected",
    name: "Rejected",
    value: 4,
    background: "rgba(255,171,145,0.16)",
    color: "#d32f2f",
    nextStatuses: [
      {
        label: "Draft",
        name: "Draft",
        value: 1,
        background: "rgba(145,158,171,0.16)",
        color: "#637381"
      }
    ]
  },
  {
    label: "Assigned",
    name: "Assigned",
    value: 5,
    background: "rgba(255,249,196,0.16)",
    color: "#fbc02d",
    nextStatuses: [
      {
        label: "In Use",
        name: "In Use",
        value: 6,
        background: "rgba(200,230,201,0.16)",
        color: "#66bb6a"
      },
      {
        label: "Returned",
        name: "Returned",
        value: 8,
        background: "rgba(179,229,252,0.16)",
        color: "#0288d1"
      }
    ]
  },
  {
    label: "In Use",
    name: "In Use",
    value: 6,
    background: "rgba(200,230,201,0.16)",
    color: "#66bb6a",
    nextStatuses: [
      {
        label: "In Maintenance",
        name: "In Maintenance",
        value: 7,
        background: "rgba(255,224,178,0.16)",
        color: "#fb8c00"
      },
      {
        label: "Returned",
        name: "Returned",
        value: 8,
        background: "rgba(179,229,252,0.16)",
        color: "#0288d1"
      }
    ]
  },
  {
    label: "In Maintenance",
    name: "In Maintenance",
    value: 7,
    background: "rgba(255,224,178,0.16)",
    color: "#fb8c00",
    nextStatuses: [
      {
        label: "In Use",
        name: "In Use",
        value: 6,
        background: "rgba(200,230,201,0.16)",
        color: "#66bb6a"
      },
      {
        label: "Returned",
        name: "Returned",
        value: 8,
        background: "rgba(179,229,252,0.16)",
        color: "#0288d1"
      }
    ]
  },
  {
    label: "Returned",
    name: "Returned",
    value: 8,
    background: "rgba(179,229,252,0.16)",
    color: "#0288d1",
    nextStatuses: [
      {
        label: "Disposed",
        name: "Disposed",
        value: 9,
        background: "rgba(215,204,200,0.16)",
        color: "#6d4c41"
      }
    ]
  },
  {
    label: "Disposed",
    name: "Disposed",
    value: 9,
    background: "rgba(215,204,200,0.16)",
    color: "#6d4c41",
    nextStatuses: []
  }
];




const DEFAULT_TEMPLATES = [{
  name: 'Software development',
  type: 'Development',
  activityTypes: KO_DEVELOPMENT,
  description: 'Manage and track all phases of software development projects efficiently.',
  icon: 'IssuesOutlined',
  isDefault: true,
  templateType:'Software development',
  workflow: PROJECT_WORKFLOW,
  templateId: 1
},
{
  name: 'IT Support',
  type: 'Helpdesk',
  activityTypes: IT_SUPPORT,
  description: 'Streamline issue resolution and maintain SLA-compliant support with intelligent ticketing and real-time collaboration tools.',
  icon: 'SupportOutlined',
  isDefault: true,
  workflow: IT_SERVICE_MANAGEMENT_WORKFLOW,
  templateId: 18
}, {
  name: 'Order management',
  type: 'Orders',
  activityTypes: ORDER_MANAGEMENT_ISSUE_TYPES,
  description: 'Handle customer orders, fulfillment, and tracking in a streamlined process.',
  icon: '',
  isDefault: true,
  workflow: ORDER_WORKFLOW,
  templateId: 2
},
{
  name: 'Customer support',
  type: 'Support',
  activityTypes: CUSTOMER_SUPPORT_TYPES,
  description: 'Deliver fast, reliable support to every shopper. Centralize support tickets, streamline resolutions, and keep your customers coming back — with real-time visibility and workflow automation.',
  icon: 'SupportOutlined',
  isDefault: true,
  workflow: CUSTOMER_SUPPORT_WORKFLOW,
  templateId: 19
},
{
  name: 'Sales prospecting',
  type: 'Sales',
  activityTypes: SALES_PROSPECTING_TYPES,
  description: 'Streamline Your Sales Prospecting Workflow Turn cold leads into hot deals with automated workflows that drive consistent conversions.',
  icon: 'SalesOutlined',
  isDefault: true,
  workflow: SALES_LEAD_WORKFLOW,
  templateId: 3
}, {
  name: 'Sales service management',
  type: 'Sales',
  activityTypes: SALES_SERVICE_TYPES,
  description: 'The Sales Service Management Workflow outlines the complete journey from lead acquisition to service fulfillment, ensuring smooth transitions between sales and service teams. It helps drive efficiency, customer satisfaction, and accountability across all stages.',
  icon: 'SalesOutlined',
  isDefault: true,
  workflow: SALES_SERVICE_WORKFLOW,
  templateId: 4
},
{
  name: 'Sales pipeline',
  type: 'Sales',
  activityTypes: SALES_PIPELINE_TYPES,
  description: 'Track your sales pipeline from lead to close—all in one place. Kwapio helps sales teams stay organized, forecast revenue, and close deals faster.',
  icon: 'SalesOutlined',
  isDefault: true,
  workflow: PROJECT_SALES_MANAGEMENT_WORKFLOW,
  templateId: 10
},
// {
//   name: 'Event Planning',
//   type: 'Events',
//   description: `Streamline Your Event Planning from Concept to Follow-Up." Effortlessly manage budgeting, promotion, and execution for successful events every time`,
//   icon: 'CalendarOutlined',
//   isDefault: true,
//   workflow: EVENT_WORKFLOW,
//   templateId: 9,
//   activityTypes: EVENT_PLANNING_TYPES
// },
{
  name: 'Marketing project management',
  type: 'Marketing',
  description: `From Idea to Impact – Seamlessly Manage Marketing Projects with Transparency and Speed.
Plan smarter, execute faster, and collaborate better with a structured yet flexible project flow tailored for modern marketing teams.`,
  icon: 'MarketingOutlined',
  isDefault: true,
  workflow: PROJECT_MARKETING_MANAGEMENT_WORKFLOW,
  templateId: 5,
  activityTypes: MARKETING_PROJECT_MANAGEMENT_TYPES
},
{
  name: 'Campaign management',
  type: 'Marketing',
  description: `Run Marketing Campaigns with Precision, Speed, and Full Team Visibility.From strategy to launch, manage every step in one seamless workspace`,
  icon: 'MarketingOutlined',
  isDefault: true,
  workflow: CAMPAIGN_MANAGEMENT_WORKFLOW,
  templateId: 6,
  activityTypes: CAMPAIGN_MANAGEMENT_TYPES
},
{
  name: 'Content management',
  type: 'Marketing',
  description: 'Streamline your content creation process with our efficient content management workflow. From drafting to publishing, ensure smooth collaboration and timely execution.',
  icon: 'MarketingOutlined',
  isDefault: true,
  workflow: CONTENT_MANAGEMENT_WORKFLOW,
  templateId: 7,
  activityTypes: CONTENT_MANAGEMENT_TYPES
},
{
  name: 'Email campaign',
  type: 'Marketing',
  description: `Transform your email marketing with a streamlined workflow that takes your campaign from idea to inbox. Create, design, approve, and send with ease for maximum impact`,
  icon: 'MarketingOutlined',
  isDefault: true,
  workflow: EMAIL_CAMPAIGN_WORKFLOW,
  templateId: 8,
  activityTypes: EMAIL_CAMPAIGN_TYPES
},
{
  name: 'Finance service management',
  type: 'Finance',
  description: `Streamline Budget Requests, Approvals, and Disbursements with Full Traceability. From submission to closure, manage department and event budgets with CFO-level oversight and control.`,
  icon: 'InvoicesOutlined',
  isDefault: true,
  workflow: FINANCE_SERVICE_WORKFLOW,
  templateId: 11,
  activityTypes: FINANCIAL_OPERATIONS_TYPES
},
{
  name: 'Budget creation',
  type: 'Finance',
  description: 'Manage and track all phases of software development projects efficiently.',
  icon: 'InvoicesOutlined',
  isDefault: true,
  workflow: BUDGET_CREATION_WORKFLOW,
  templateId: 12,
  activityTypes: BUDGET_CREATION_TYPES
},
{
  name: 'Project finance management',
  type: 'Finance',
  description: 'Manage and track all phases of software development projects efficiently.',
  icon: 'InvoicesOutlined',
  isDefault: true,
  workflow: PROJECT_FINANCE_MANAGEMENT_WORKFLOW,
  templateId: 13,
  activityTypes: PROJECT_FINANCE_MANAGEMENT_TYPES
},
{
  name: 'HR service management',
  type: 'HR',
  description: `Streamline employee support with a clear, trackable HR service flow. From simple queries to complex escalations, manage everything in one place. Boost employee satisfaction with faster, more transparent resolutions.`,
  icon: 'HrOutlined',
  isDefault: true,
  workflow: HR_SERVICE_MANAGEMENT_WORKFLOW,
  activityTypes: HR_SERVICE_MANAGEMENT_TYPES,
  templateId: 14
},
{
  name: 'Recruitment',
  type: 'HR',
  description: `Streamline your recruitment process from job creation to hiring, ensuring a smooth and efficient candidate journey.Make faster decisions, improve candidate experience, and fill positions with the right talent.`,
  icon: 'HrOutlined',
  isDefault: true,
  workflow: RECRUITMENT_WORKFLOW,
  templateId: 15,
  activityTypes: RECRUITMENT_TYPES
},
{
  name: 'Policy management',
  type: 'HR',
  description: `Streamline policy creation, approval, and distribution with a simple, efficient system. Ensure compliance, consistency, and clarity across your organization with every policy update.`,
  icon: 'HrOutlined',
  isDefault: true,
  workflow: POLICY_MANAGEMENT_WORKFLOW,
  templateId: 16,
  activityTypes: POLICY_MANAGEMENT_TYPES
}, {
  name: 'Performance review',
  type: 'HR',
  description: `Simplify and enhance employee evaluations with a streamlined performance review system. Drive growth by offering feedback, setting clear goals, and fostering continuous development.`,
  icon: 'HrOutlined',
  isDefault: true,
  workflow: PERFORMANCE_REVIEW_WORKFLOW,
  templateId: 17,
  activityTypes: PERFORMANCE_REVIEW_TYPES
},
{
  name: 'Product Development',
  type: 'Development',
  activityTypes: KO_DEVELOPMENT,
  description: 'Manage and track all phases of software development projects efficiently.',
  icon: 'IssuesOutlined',
  isDefault: true,
  workflow: PROJECT_WORKFLOW,
  templateId: 20
},
{
  name: 'Managed Service Provider',
  type: 'Development',
  activityTypes: KO_DEVELOPMENT,
  description: 'Manage and track all phases of software development projects efficiently.',
  icon: 'IssuesOutlined',
  isDefault: true,
  workflow: PROJECT_WORKFLOW,
  templateId: 21
},
{
  name: 'Asset Management',
  type: 'Assets',
  description: 'Manage, track, and maintain assets through their full lifecycle.',
  icon: 'AssetsOutlined',
  isDefault: true,
  workflow: ASSET_MANAGEMENT_WORKFLOW,
  templateId: 22,
  activityTypes: ASSET_MANAGEMENT_TYPES
}
];

export {
  PROJECT_WORKFLOW,
  ORDER_WORKFLOW,
  DEFAULT_TEMPLATES,
  SALES_SERVICE_WORKFLOW
};